const BAR_COLOR = "#000000";

export { BAR_COLOR };